import React from 'react';
import { cropColors } from '../utils/cropColors';

interface CropLegendProps {
  isOpen: boolean;
  onToggle: () => void;
  visibleCrops?: string[];
}

const CropLegend: React.FC<CropLegendProps> = ({ isOpen, onToggle, visibleCrops = [] }) => {
  const uniqueCrops = new Set<string>();

  // Filter and map crops, ensuring uniqueness - only show crops that are in visibleCrops
  const legendItems = cropColors
    .filter(crop => {
      // Only show crops that are in the visibleCrops array
      if (visibleCrops.includes(crop.name)) {
        if (!uniqueCrops.has(crop.name)) {
          uniqueCrops.add(crop.name);
          return true;
        }
      }
      return false;
    })
    .map((crop, index) => (
      <div key={index} className="legend-item">
        <div 
          className="color-box" 
          style={{ backgroundColor: crop.color }}
        ></div>
        <span className="crop-name">{crop.name}</span>
      </div>
    ));

  return (
    <div className={`crop-legend ${isOpen ? 'open' : ''}`}>
      <button 
        className="legend-toggle"
        onClick={onToggle}
        title={isOpen ? 'Hide Legend' : 'Show Legend'}
      >
        {isOpen ? '×' : '≡'}
      </button>
      
      <div className="legend-content">
        <h3>2024 Crops</h3>
        <div className="legend-items">
          {legendItems}
        </div>
      </div>
    </div>
  );
};

export default CropLegend; 